import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";

export const findPersonAddress = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/information/address`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/information/address', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /information/address`);
    })
}

export const useFindPersonAddress = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPersonAddress(data),
    });
}

export const findPersonPhone = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/information/telephone`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/information/telephone', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /information/telephone`);
    })
}

export const useFindPersonPhone = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPersonPhone(data),
    });
}

export const findPersonPhoneHistory = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/information/history/telephone`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/information/history/telephone', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /information/history/telephone`);
    })
}

export const useFindPersonPhoneHistory = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPersonPhoneHistory(data),
    });
}

export const findPersonEmails = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/information/email`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/information/email', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /information/email`);
    })
}

export const useFindPersonEmails = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPersonEmails(data),
    });
}

